import styled from 'styled-components';

export const DynaimcShelfHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  h3 {
    font-weight: 400;
    margin-bottom: 10px;
  }
`;

export const SeeAllButton = styled.div`
  display: flex;
  align-self: flex-end;
  align-items: flex-start;
  color: #E60000;
  cursor: pointer;
  white-space: nowrap;

  @media (max-width: 794px) {
    margin-top: 5px;
    align-self: flex-start;
  }

  [class*='Iconstyle__Icon-sc'] {
    margin-left: 3px;
    margin-top: 5px;

    @media (max-width: 757px) {
      margin-top: 1px;
    }
  }
`;

export const CarouselWrapper = styled.div<{
  direction: 'rtl' | 'ltr';
}>`
  width: ${props => props.direction};
  [class*='CarouselArrowstyle__CarouselArrow-sc'] {
    display: none;
  }

  @media (max-width: 794px) {
    display: none;
  }

  .slick-slide {
    margin: 0 10px;
    padding: 1em 0 1em 0;
  }

  .slick-track {
    margin-left: ${props => props.direction === 'ltr' && '0'};
    margin-right: ${props => props.direction === 'rtl' && '0'};
  }

  .slick-list {
    margin: 0 -10px;
  }
`;

export const ShelfArticleWrapper = styled.div`
  text-align: left;
  height: 100%;

  @media (max-width: 794px) {
    margin: 2em 0 2em 0;

    .gatsby-image-wrapper {
      height: 250px;
    }
  }
`;

export const MobileShelfWrapper = styled.div`
  text-align: left;

  @media (min-width: 795px) {
    display: none;
  }
`;
